import { render, staticRenderFns } from "./AutoMail.vue?vue&type=template&id=2c304e5d&scoped=true&"
import script from "./AutoMail.vue?vue&type=script&lang=ts&"
export * from "./AutoMail.vue?vue&type=script&lang=ts&"
import style0 from "./AutoMail.vue?vue&type=style&index=0&id=2c304e5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c304e5d",
  null
  
)

export default component.exports